<div class="flex flex-col h-full w-full p-3 max-h-full overflow-hidden px-8">
  <div class="w-full max-w-full block lg:h-fit sm:h-[14%]">
    <app-plant-details [categoryId]="'2'"></app-plant-details>
  </div>



  <div
    class="flex flex-wrap justify-between sm:gap-3 lg:gap-1.5 sm:mt-1 lg:mt-[1%] items-center flex-grow overflow-auto w-full"
  >
   
    <div
      class="lg:w-[66.4%] xl:h-[258px] lg:h-[240px] md:w-[64.8%] sm:w-full sm:py-6 sm:px-5 lg:py-4 lg:px-4 sm:h-[15.9 rem] md:h-[17.2rem] lg:max-h-unset bg-[#252A30] flex flex-col rounded-2xl border-box text-white"
    >
      <div class="lg:pt-2 sm:pt-0.5">
        <span class="text-base font-medium text-white">{{
          "solar_summary" | translate
        }}</span>
      </div>
      <div class="flex justify-between sm:pt-4 md:pt-6">
        <div class="">
          <div class="flex flex-col pb-6">
            <span class="text-sm text-card-text pb-2 text-dark-gray-content">{{
              "current_generation" | translate
            }}</span>
            <span class="text-[18px] text-white font-normal mt-3">
              {{ solarPlantResponse.currentGeneration }}</span
            >
          </div>
          <div class="flex flex-col lg:mt-1 xl:mt-1.5">
            <span class="text-sm text-card-text pb-2 text-dark-gray-content"
              >{{ "lifetime_saving" | translate }}
            </span>
            <span class="text-[18px] text-white font-normal mt-3">
              {{
                convertScientificNotation(
                  solarPlantResponse.lifetimeSavings.toString(),
                  "lifetimeSavings"
                )
              }}</span
            >
          </div>
        </div>
        <div class="">
          <div class="flex flex-col pb-6">
            <span class="text-sm text-card-text pb-2 text-dark-gray-content">{{
              "today_generation" | translate
            }}</span>
            <span class="text-[18px] text-white font-normal mt-3"
              >{{ solarPlantResponse.todayGeneration }}
            </span>
          </div>
          <div class="flex flex-col lg:mt-1 xl:mt-1.5">
            <span class="text-sm text-card-text pb-2 text-dark-gray-content">{{
              "return_on_investment" | translate
            }}</span>
            <span class="text-[18px] text-white font-normal mt-3">
              {{
                solarPlantResponse.roi > 100 ? 100 : solarPlantResponse.roi
              }}%</span
            >
          </div>
        </div>
        <div class="">
          <div class="flex flex-col pb-6">
            <span class="text-sm text-card-text pb-2 text-dark-gray-content"
              >{{ "lifetime_generation" | translate }}
            </span>
            <span class="text-[18px] text-white font-normal mt-3">
              {{
                convertScientificNotation(solarPlantResponse.lifetimeGeneration)
              }}
            </span>
          </div>
          <div class="flex flex-col lg:mt-1 xl:mt-1.5">
            <span class="text-sm text-card-text pb-2 text-dark-gray-content">
              {{ "total_solar_capacity" | translate }}</span
            >
            <span class="text-[18px] text-white font-normal mt-3">
              {{ solarPlantResponse.totalSolarCapacity }}</span
            >
          </div>
        </div>
      </div>
    </div>

    
    <div
      class="flex flex-col lg:w-[32.7%] xl:h-[258px] lg:h-[240px] md:w-[33.8%] sm:w-full md:h-[17.2rem] rounded-2xl bg-[#252A30] border-box text-white sm:py-6 sm:px-5 lg:py-4 lg:px-4"
    >
      <div class="lg:pt-2 sm:pt-0.5">
        <span class="text-base font-medium text-white">{{
          "environmental_benefits" | translate
        }}</span>
      </div>

      <div class="lg:flex sm:hidden md:flex-col flex-grow pt-4 justify-between">
       
        <div class="flex items-center">
          <div class="flex md:flex-col lg:flex-row lg:items-center">
            <div>
              <img
                class="xl:w-10 xl:h-10 sm:h-6 sm:w-6 md:w-[34px] md:h-[34px]"
                src="../../../../../assets/svg/equivalent_trees_planted.svg"
                alt="Trees Icon"
              />
            </div>
            <div>
              <span class="text-[18px] ml-2 text-white font-normal">{{
                solarPlantResponse.equivalentTreesPlanted
              }}</span>
            </div>
          </div>
          <div>
            <span
              class="text-sm text-card-text pb-2 ml-5 text-dark-gray-content"
              >{{ "equivalent_trees_planted" | translate }}</span
            >
          </div>
        </div>

       
        <div class="flex items-center">
          <div class="flex sm:flex-col lg:flex-row lg:items-center">
            <div>
              <img
                class="xl:w-10 xl:h-10 sm:h-7 sm:w-7 md:w-[34px] md:h-[34px]"
                src="../../../../../assets/svg/co2_emission_saved.svg"
                alt="Trees Icon"
              />
            </div>
            <div>
              <span class="text-[18px] ml-2 text-white font-normal">
                {{
                  convertScientificNotation(solarPlantResponse.co2EmissionSaved)
                }}
              </span>
            </div>
          </div>
          <div>
            <span
              class="text-sm text-card-text pb-2 ml-5 text-dark-gray-content"
              >CO<sub>2</sub> Emission Saved</span
            >
          </div>
        </div>

       
        <div class="flex items-center">
          <div class="flex md:flex-col lg:flex-row lg:items-center">
            <div>
              <img
                class="xl:w-10 xl:h-10 sm:h-6 sm:w-6 md:w-[34px] md:h-[34px]"
                src="../../../../../assets/svg/coal_not_burnt.svg"
                alt="Trees Icon"
              />
            </div>
            <div>
              <span class="text-[18px] ml-2 text-white font-normal">
                {{ solarPlantResponse.coalNotBurned }}
              </span>
            </div>
          </div>
          <div>
            <span
              class="text-sm text-card-text pb-2 ml-5 text-dark-gray-content"
              >{{ "coal_not_burned" | translate }}</span
            >
          </div>
        </div>
      </div>
      <!--for small brealpoints -->
      <div
        class="sm:flex lg:hidden flex-grow sm:flex-row md:flex-col justify-between pt-4"
      >
        <div class="items-center flex">
          <div>
            <img
              class="xl:w-10 xl:h-10 sm:h-6 sm:w-6 md:w-[34px] md:h-[34px]"
              src="../../../../../assets/svg/equivalent_trees_planted.svg"
              alt="Trees Icon"
            />
          </div>
          <div
            class="flex sm:flex-col lg:items-center lg:flex-row ml-3 flex-grow w-full"
          >
            <div class="text-[18px] text-white font-normal">
              <span
                class="text-white text-[18px] lg:text-md font-normal pt-1 md:pt-0"
                >{{ solarPlantResponse.equivalentTreesPlanted }}</span
              >
            </div>
            <div>
              <span class="text-xs lg:text-md text-dark-gray-content"
                >{{ "equivalent_trees_planted" | translate }}
              </span>
            </div>
          </div>
        </div>
        
        <div class="flex items-center">
          <div>
            <img
              class="xl:w-10 xl:h-10 sm:h-7 sm:w-7 md:w-[34px] md:h-[34px]"
              src="../../../../../assets/svg/co2_emission_saved.svg"
              alt="Trees Icon"
            />
          </div>
          <div class="flex sm:flex-col lg:flex-row lg:items-center ml-3 w-full">
            <div>
              <span
                class="text-white text-[18px] lg:text-md font-normal pt-1 md:pt-0"
              >
                {{
                  convertScientificNotation(solarPlantResponse.co2EmissionSaved)
                }}
              </span>
            </div>
            <div>
              <span class="text-xs lg:text-md text-dark-gray-content"
                >CO<sub>2</sub> Emission Saved</span
              >
            </div>
          </div>
        </div>
       
        <div class="flex items-center">
          <div>
            <img
              class="xl:w-10 xl:h-10 sm:h-6 sm:w-6 md:w-[34px] md:h-[34px]"
              src="../../../../../assets/svg/coal_not_burnt.svg"
              alt="Trees Icon"
            />
          </div>
          <div class="flex sm:flex-col lg:flex-row lg:items-center ml-3 w-full">
            <div>
              <span
                class="text-white text-[18px] lg:text-md font-normal pt-1 md:pt-0"
              >
                {{ solarPlantResponse.coalNotBurned }}
              </span>
            </div>

            <div>
              <span class="text-xs lg:text-md text-dark-gray-content">{{
                "coal_not_burned" | translate
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="lg:w-[100%] lg:min-h-[300px] lg:max-h-fit lg:m-[0.4%] sm:py-6 sm:px-5 lg:py-4 lg:px-4 sm:w-full sm:h-[22rem] p md:w-full sm:max-h-fit bg-[#252A30] flex flex-col rounded-2xl border-box text-white"
    >
      <div class="w-full h-full">
        <app-trends [categoryId]="'1'" [categoryTitle]="'solar'"></app-trends>
      </div>
    </div>
   
    <div
      class="flex flex-col lg:w-[32.7%] lg:h-[313px] xxl:h-[370px] sm:h-[16.1rem] md:h-[18rem] sm:order-5 lg:order-4 rounded-2xl lg:min-h-[310px] bg-[#252A30] border-box text-white sm:py-6 sm:px-5 lg:py-4 lg:px-4 sm:w-full md:w-[49.3%]"
    >
      <div class="lg:pt-2 sm:pt-0.5">
        <span class="text-base font-medium text-white">{{
          "plant_health" | translate
        }}</span>
      </div>
      <div class="flex justify-center items-center flex-grow">
        <div
          class="sm:w-9/12 md:w-11/12 lg:w-11/12 xxl:w-10/12 h-full flex items-center justify-center"
        >
          <div class="lg:w-[53%] sm:w-[40%] md:w-[40%] xxl:w-[50%]">
            <app-radial-bar
              [dataLabel]="'Healthy'"
              [dataSeries]="solarPlantHealth"
              [maxSize]="170"
            ></app-radial-bar>
          </div>
          <div class="flex flex-col pl-4">
            <div class="text-center">
              <span class="text-lg">{{
                solarPlantResponse.totalSolarPlants
              }}</span>
            </div>
            <div class="mt-4 text-center">
              <span class="text-base text-dark-gray-content">{{
                "solar" | translate
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
   
    <div
      class="flex flex-col lg:w-[32.7%] lg:h-[313px] xxl:h-[370px] sm:h-[15.8rem] md:h-[18rem] sm:order-6 lg:order-5 rounded-2xl lg:min-h-[310px] bg-[#252A30] border-box text-white sm:py-6 sm:px-5 lg:py-4 lg:px-4 sm:w-full md:w-[49.3%]"
    >
      <app-today-alerts [categoryId]="'2'"></app-today-alerts>
    </div>
 
    <div
      class="lg:w-[32.7%] lg:h-[313px] xxl:h-[370px] sm:h-[15.8rem] md:h-[18rem] sm:order-4 sm:w-full lg:order-6 flex bg-[#252A30] md:flex-row sm:flex-col items-center text-white rounded-2xl p-4"
    >
      <div class="w-full h-full">
        <app-powercut-and-summary [categoryId]="'2'"></app-powercut-and-summary>
      </div>
    </div>
  </div>
</div>
